import React, { useState } from 'react'
import { Resizable } from 'react-resizable'

const ResizableSidebar = ({children}) => {
    const [width, setWidth] = useState(500)
    const onResize = (event, { size }) => {
        setWidth(size.width)
    }
    return (
        <Resizable
            maxConstraints={[Infinity, Infinity]}
            minConstraints={[500, Infinity]}
            height={Infinity}
            width={width}
            axis='x'
            onResize={onResize}
            resizeHandles={['w']}
            handle={<div className="absolute top-0 bottom-0 w-0.5" style={{cursor: "ew-resize"}}/>}
        >
            <div style={{ width: width + 'px'}}>
                {children}
            </div>
        </Resizable>
    )
}

export default ResizableSidebar
